export default __webpack_public_path__ + "static/media/4th.7d3e95af.PNG";